import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, timeout: 20000 });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("ab_admin_token");
    if (token && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (error) => {
        if (error?.response?.status === 401) {
            localStorage.removeItem("ab_admin_token");
            localStorage.removeItem("ab_admin_username");
        }
        return Promise.reject(error);
    },
);

export default api;

// -- Convenience wrappers ---------------------------------------------------
export const login = (username, password) => api.post("/auth/login", { username, password });
export const me = () => api.get("/auth/me");
export const changePassword = (current_password, new_password) => api.post("/auth/change-password", { current_password, new_password });

export const getSection = (section) => api.get(`/content/${section}`).then((r) => r.data);
export const putSection = (section, data) => api.put(`/content/${section}`, { section, data });
export const listItems = (kind) => api.get(`/${kind}`).then((r) => r.data);
export const createItem = (kind, payload) => api.post(`/${kind}`, payload).then((r) => r.data);
export const updateItem = (kind, id, payload) => api.put(`/${kind}/${id}`, payload).then((r) => r.data);
export const deleteItem = (kind, id) => api.delete(`/${kind}/${id}`).then((r) => r.data);
export const reorderItems = (kind, ids) => api.post(`/${kind}/reorder`, ids).then((r) => r.data);
export const getMedia = (key) => api.get(`/media/${key}`).then((r) => r.data);
export const uploadMedia = (key, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post(`/media/upload?key=${encodeURIComponent(key)}`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
};
export const getStats = () => api.get("/admin/stats").then((r) => r.data);
export const listMessages = () => api.get("/contact-messages").then((r) => r.data);
export const submitContact = (payload) => api.post("/contact-messages", payload).then((r) => r.data);
export const deleteMessage = (id) => api.delete(`/contact-messages/${id}`).then((r) => r.data);
export const markMessageRead = (id) => api.put(`/contact-messages/${id}/read`).then((r) => r.data);
